import { render, staticRenderFns } from "./Submodules.vue?vue&type=template&id=a2c123bc&"
import script from "./Submodules.vue?vue&type=script&lang=js&"
export * from "./Submodules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports